<template>
    <el-dialog :bodyStyle="{bodyStyle: 0}" class="online-preview-dialog" append-to-body center :title="name"
        :visible.sync="dialogVisible" width="100vw" top="0px" destroy-on-close>
        <div class="online_preview_container">
            <iframe width="100%" ref="iframe" :src="src" frameborder="0" scrolling="auto" style="width:100%;height:calc(100% - 5px);"></iframe>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'OnlinePreview',
    props: ['value', 'src', 'name', 'suffix'],
    computed: {
        dialogVisible: {
            get () {
                return this.value
            },
            set (newVal) {
                this.$emit('input', newVal)
            }
        }
    },
    methods: {
        
    },
}
</script>
<style scoped>
    .online_preview_container {
        width: 100%;
        height: calc(100vh - 55px);
    }
    /deep/.el-dialog__body {
      padding: 0!important;
    }
</style>